/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { createContext, ReactNode, useCallback, useContext, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import useComments from '../common/hooks/useComments';

const useCommunicationData = () => {
  const comments = useComments();
  const [creating, setCreating] = useState(false);

  return { ...comments, creating, setCreating };
};

type TUseCommunicationData = ReturnType<typeof useCommunicationData>;

// Create a context to store login data
const CommunicationContext = createContext<TUseCommunicationData | undefined>(undefined);

// Custom hook to use the CommunicationContext
export const useCommunicationContext = (): TUseCommunicationData => {
  const communicationContext = useContext(CommunicationContext);

  if (!communicationContext) {
    // throwing this error helps in development when the context is out of scope.
    throw new Error('useCommunicationContext must be used within a CommunicationProvider');
  }

  return communicationContext;
};

type TCommunicationProviderProps = {
  children: ReactNode;
};

// Provider component for CommunicationContext
export const CommunicationProvider = ({ children }: TCommunicationProviderProps) => {
  return <CommunicationContext.Provider value={useCommunicationData()}>{children}</CommunicationContext.Provider>;
};
